export const TIMELINE_DEFAULT_ARROW_HEAD_LENGTH = 8
export const TIMELINE_DEFAULT_ARROW_HEAD_WIDTH = 6
export const TIMELINE_DEFAULT_ARROW_MARGIN = 3
